﻿import { DateString } from '@core/_globals/types/date-settings';
import util from '@core/services/util';

export default class ApplicationsEmployment {
	employerName?: string = null;
	phone?: string = null;
	position?: string = null;
	supervisorFirstName?: string = null;
	supervisorLastName?: string = null;
	supervisorPhone?: string = null;
	startDate?: DateString = null;
	payType?: any = null; // Possible Values: hourly, salary
	payAmount?: number = null;
	getPaidOvertime?: boolean = null;
	weeklyHours?: any = null;
	commissionsAndBonusesAmount?: any = null;
	commissionsAndBonusesFrequency?: any = null; // Possible Values: weekly, bi-weekly, monthly, annually
	commissionsAndBonusesDescription?: string = null;

	constructor(init?: ApplicationsEmployment) {
		if (init) {
			this.employerName = init.employerName;
			this.phone = init.phone;
			this.position = init.position;
			this.supervisorFirstName = init.supervisorFirstName;
			this.supervisorLastName = init.supervisorLastName;
			this.supervisorPhone = init.supervisorPhone;
			this.startDate = init.startDate ?? null;
			this.payType = init.payType;
			this.payAmount = init.payAmount;
			this.getPaidOvertime = init.getPaidOvertime;
			this.weeklyHours = init.weeklyHours;
			this.commissionsAndBonusesAmount = init.commissionsAndBonusesAmount;
			this.commissionsAndBonusesFrequency = init.commissionsAndBonusesFrequency;
			this.commissionsAndBonusesDescription = init.commissionsAndBonusesDescription;
		}
	}

	getEmployerPhoneNumberFormatted() {
		return util.formatPhoneNumber(this.phone);
	}

	getEmployerNameProper() {
		return util.toProperCase(this.employerName);
	}
}
